import styled from 'styled-components';

const SearchContainer = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    padding: 1.2rem 1.5rem;
`;

export default SearchContainer;
